import { classicStyles } from "./classic.js";
import { modernStyles } from "./modern.js";
import { minimalStyles } from "./minimal.js";
import { executiveStyles } from "./executive.js";
import { compactStyles } from "./compact.js";
import { ivoryStyles } from "./ivory.js";
import { azureStyles } from "./azure.js";
import { sapphireStyles } from "./sapphire.js";
import { cobaltStyles } from "./cobalt.js";
import { emeraldStyles } from "./emerald.js";

// Registry of available templates. To add a template:
//   1. Create new file `templates/<key>.js` exporting a styles object
//   2. Add it here with a label
//   3. It will appear in the template selector automatically
export const TEMPLATES = {
  classic: { label: classicStyles.meta.label, styles: classicStyles },
  modern: { label: modernStyles.meta.label, styles: modernStyles },
  minimal: { label: minimalStyles.meta.label, styles: minimalStyles },
  azure: { label: azureStyles.meta.label, styles: azureStyles },
  sapphire: { label: sapphireStyles.meta.label, styles: sapphireStyles },
  emerald: { label: emeraldStyles.meta.label, styles: emeraldStyles },
  cobalt: { label: cobaltStyles.meta.label, styles: cobaltStyles },
  executive: { label: executiveStyles.meta.label, styles: executiveStyles },
  compact: { label: compactStyles.meta.label, styles: compactStyles },
  ivory: { label: ivoryStyles.meta.label, styles: ivoryStyles },
};

export const DEFAULT_TEMPLATE = "classic";
